import { forwardRef } from "react";
import { Command as CommandPrimitive } from "cmdk";

import {
  COMBOBOX_SEARCH_ICON,
  type TComboboxInputElement,
  type TComboboxInputProps,
} from "@/ui/components/form/Combobox/Combobox.config";
import { Icon } from "@/ui/components/primitives/Icon";
import { cn } from "@/ui/lib/utils";

export const ComboboxInput = forwardRef<TComboboxInputElement, TComboboxInputProps>(
  (
    {
      className,
      ...props
    },
    ref,
  ) => (
    <div
      data-component="ComboboxInputWrapper"
      className="flex items-center gap-2 border-b border-solid border-component-input-default px-2"
    >
      <Icon
        icon={COMBOBOX_SEARCH_ICON}
        aria-hidden="true"
        size="sm"
        className="shrink-0 opacity-50"
      />
      <CommandPrimitive.Input
        data-component="ComboboxInput"
        ref={ref}
        className={cn(
          "flex h-10 w-full rounded-sys-sm bg-transparent py-2 text-sm outline-none",
          "placeholder:text-foreground-muted disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        {...props}
      />
    </div>
  ),
);

ComboboxInput.displayName = CommandPrimitive.Input.displayName;
